// ---------------------------------------------------------------------------
// 入力を自動保存する画面の共通の仕組み（#177。画面は apps/web/src/lib/saveQueue.tsx の useSaveQueue）。
// 保存が終わっていない・失敗しているときに 発行・PDF・送信・印刷・出力（工程表の Excel・PDF・CSV、#179）を押したときの文。{action} はその動き、{reason} は保存できない理由
// ---------------------------------------------------------------------------

export const SAVE_GATE_MSG = {
  blocked: "保存できていないため{action}できません：{reason}",
  /** 送り終えるのを待ちきれなかった（つながらないまま など） */
  notYet: "保存が終わっていません",
  issue: "発行",
  pdf: "PDF を表示",
  send: "送信",
  print: "印刷",
  export: "出力",
  /** 仕入の確定（#233 3a） */
  confirm: "確定",
} as const;

export type SaveGateAction = "issue" | "pdf" | "send" | "print" | "export" | "confirm";

/** 「保存できていないため発行できません：率の行には率（%）と基礎が要ります」。英字で始まる動き（PDF）は和文との間を空ける（「ため PDF を表示できません」） */
export const saveGateText = (action: SaveGateAction, reason: string): string => {
  const a = SAVE_GATE_MSG[action];
  return SAVE_GATE_MSG.blocked.replace("{action}", /^[A-Za-z]/.test(a) ? ` ${a}` : a).replace("{reason}", reason);
};
